<template>
  <div>
    <Carousel :carousel="carousel" :mobile="mobile" />
    <About />
    <Clients :clients="clients" />
    <Testmonial :testimonial="testimonial" />
  </div>
</template>

<script>
import Vue from "vue";
import VueI18n from "vue-i18n";

import Carousel from "../shared/carousel/Carousel.vue";
import About from "../shared/About.vue";
import HomeService from "../../domain/HomeService";
import Clients from "../shared/Clients.vue";
import Testmonial from "../shared/Testimonial";

export default {
  props: ["titulo"],
  components: {
    Carousel,
    About,
    Clients,
    Testmonial
  },
  data() {
    return {
      home: [],
      clients: [],
      clippings: [],
      testimonial: [],
      carousel: [],
      mobile: null
    };
  },
  watch: {
    "$i18n.locale": function() {
      this.init();
    }
  },
  methods: {
    verifyMobile() {
      if (window.innerWidth < 768) {
        this.mobile = true;
        return this.mobile;
      } else {
        this.mobile = false;
        return this.mobile;
      }
    },
    init() {
      Vue.http.headers.common["Content-Language"] = this.$i18n.locale;

      this.service.clientelist().then(res => {
        this.clients = res;
        return this.clients;
      });

      this.service.Testimonials().then(res => {
        this.testimonial = res;
        return this.testimonial;
      });

      this.service.Clippinglist().then(res => {
        this.clippings = res;
        return this.clippings;
      });

      this.service.Carousel().then(res => {
        this.carousel = res;
        return this.carousel;
      });
    }
  },
  created() {
    this.verifyMobile();
    this.service = new HomeService(this.$resource);
    this.init();
  }
};
</script>

<style lang="scss">
h1 {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue